import { render, staticRenderFns } from "./addValue.vue?vue&type=template&id=8237c540&scoped=true&"
import script from "./addValue.vue?vue&type=script&lang=js&"
export * from "./addValue.vue?vue&type=script&lang=js&"
import style0 from "./addValue.vue?vue&type=style&index=0&id=8237c540&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8237c540",
  null
  
)

export default component.exports